module.exports = __webpack_public_path__ + "static/media/pic4.f3b23345.jpg";